<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <transition name="slidedown">
        <div v-if="crumbsVisible" class="page-crumbs">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <router-link
                :key="`crumb_${crumb.name}`"
                v-for="crumb in $route.meta.crumbs"
                :to="{ name: crumb.name }"
                tag="li"
              >
                <a
                  ><span class="link">{{ crumb.label }}</span></a
                >
              </router-link>
              <li v-if="data" class="is-active">
                <a href="#" aria-current="page">{{
                  data.gallery_settings.name
                }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </transition>
      <div class="page">
        <section class="page-section">
          <div v-if="!data">Loading...</div>
          <div v-if="data" class="section-heading">
            <br />
            <div class="title is-size-2 is-bold">
              {{ data.gallery_settings.name }}
            </div>
          </div>
          <div class="page-section-content">
            <virtual-list
              v-if="columns > 1"
              :size="250"
              :remain="3"
              class="virtual-list"
            >
              <gallery-desktop-row
                :plant="plant"
                :webp="webp"
                :key="`plant_${idx}`"
                v-for="(plant, idx) in plantsList"
              ></gallery-desktop-row>
            </virtual-list>
            <virtual-list
              v-if="columns === 1"
              :size="250"
              :remain="3"
              class="virtual-list"
            >
              <gallery-mobile-row
                :plant="plant"
                :webp="webp"
                :key="`plant_${idx}`"
                v-for="(plant, idx) in plantsList"
              ></gallery-mobile-row>
            </virtual-list>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";
import { format } from "timeago.js";
import { getGalleryData } from "@/services/gallery";
import { PlantSort } from "@/util/plant-sort";
import { ROUTE_NAMES } from "@/routes";
// import PageTile from "./../common/page-tile";
import { mapGetters } from "vuex";
// import VClamp from "vue-clamp";
// import VirtualScroller from "@/components/pages/gallery/virtual-scroller";
import GalleryDesktopRow from "@/components/pages/gallery/gallery-desktop-row";
import GalleryMobileRow from "@/components/pages/gallery/gallery-mobile-row";
// import VirtualScroller from "@/components/pages/gallery/virtual-scroller";
import VirtualList from "vue-virtual-scroll-list";

export default {
  data() {
    return {
      crumbsVisible: true,
      data: null
    };
  },
  methods: {
    timeAgo(date) {
      return format(date);
    },
    async load() {
      this.data = await getGalleryData(this.$route.params.id);
    },
    getChunk(chunk, array) {
      let i, j, temparray;
      let chunkedArray = [];
      for (i = 0, j = array.length; i < j; i += chunk) {
        temparray = array.slice(i, i + chunk);
        chunkedArray.push(temparray);
      }
      return chunkedArray;
    }
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters({ webp: "settings/webp", mediaQuery: "mediaQuery/active" }),
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    },
    columns() {
      if (this.mediaQuery !== "mobile" && this.mediaQuery !== "tablet") {
        return 4;
      }
      return 1;
    },
    plantsList() {
      if (!this.data) {
        return null;
      }
      let sorter = new PlantSort(this.data.gallery_settings.plants);
      let sortedPlants = sorter.sortPlants(this.data.plants);
      if (this.columns > 1) {
        return this.getChunk(this.columns, sortedPlants);
      }
      return sortedPlants;
    }
  },
  components: {
    // VirtualScroller,
    GalleryDesktopRow,
    GalleryMobileRow,
    // VirtualScroller,
    Page,
    // PageTile,
    // VClamp
    VirtualList
  },
  metaInfo: {
    title: "Gallery"
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.virtual-list {
  overflow-x: hidden;
}

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, $color-text, $color-selection);
  }
}

.wrapped {
  flex-wrap: wrap;
}

.cover {
  object-fit: cover;
}

.bottom-links {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>
